import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, {}, { headers: { "X-Session-ID": sessionId }, withCredentials: true })
      .then((r) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: r.data }, replace: true });
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-4 text-white">
      <Loader2 size={32} className="animate-spin text-red-500" />
      <p className="text-zinc-400 text-sm">Prijava u toku...</p>
    </div>
  );
}
